import { render, staticRenderFns } from "./areaRegistration.vue?vue&type=template&id=6e4b6cf9&scoped=true"
import script from "./areaRegistration.vue?vue&type=script&lang=js"
export * from "./areaRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b6cf9",
  null
  
)

export default component.exports